module.exports = __webpack_public_path__ + "img/helical_left_gear.prt.7479e0c4.jpg";